import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Typography,
  Card,
  Alert
} from '@mui/joy';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      navigate('/stock');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        padding: 2
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 400 }}>
        <Typography level="h2" sx={{ mb: 2, textAlign: 'center', color: '#eb7a24' }}>
          Dental Stock Login
        </Typography>

        {error && (
          <Alert color="danger" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Email</FormLabel>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your email"
              sx={{
                '&:hover': { borderColor: '#ea7a23' },
                '&:focus-within': { borderColor: '#ea7a23' }
              }}
            />
          </FormControl>

          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Password</FormLabel>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
              sx={{
                '&:hover': { borderColor: '#ea7a23' },
                '&:focus-within': { borderColor: '#ea7a23' }
              }}
            />
            <Typography level="body-xs" sx={{ mt: 0.5, textAlign: 'right' }}>
              <Link to="/forgot-password" style={{ color: '#eb7a24' }}>
                Forgot password?
              </Link>
            </Typography>
          </FormControl>

          <Button
            type="submit"
            loading={loading}
            fullWidth
            sx={{
              backgroundColor: '#eb7a24',
              '&:hover': { backgroundColor: '#cc6a1f' },
              mb: 2
            }}
          >
            Login
          </Button>
        </form>
      </Card>
    </Box>
  );
};

export default Login;

